import { reverse } from 'named-urls';
import { useNavigate } from 'react-router-dom';
import { routing } from '../../../utils/routing';
import { useDirtyContext } from '../providers/DirtyProvider';
import { usePageLayoutContext } from '../providers/PageLayoutProvider';
import { useCurrentShopContext } from './useCurrentShopContext';
import { useDuplicateSectionMutation } from './useDuplicateSectionMutation';
import { useThemeEditorContext } from './useThemeEditorContext';
export const useDuplicateSection = () => {
    const { currentPageId, resetPreviewTimestamp } = useThemeEditorContext();
    const { setIsDirty } = useDirtyContext();
    const { currentShop } = useCurrentShopContext();
    const { pageLayoutQuery } = usePageLayoutContext();
    const { duplicateSectionMutation } = useDuplicateSectionMutation();
    const navigate = useNavigate();
    const duplicateSection = (sectionKey) => {
        const section = pageLayoutQuery.data?.sectionsGroups
            .flatMap((block) => block.sections)
            .find((section) => section.sectionKey === sectionKey);
        if (!section || !currentPageId || !sectionKey) {
            throw new Error('duplicateSection: Missing section or current page ID');
        }
        setIsDirty(true);
        duplicateSectionMutation.mutate([
            {
                shop_id: currentShop.id,
                draft_section_id: section.id,
            },
        ], {
            onSuccess: (data) => {
                pageLayoutQuery.refetch();
                resetPreviewTimestamp();
                navigate(reverse(routing.themeEditorV2.layout.page.sections, {
                    pageId: currentPageId,
                    sectionKey: data.sectionKey,
                }));
            },
        });
    };
    return {
        duplicateSection,
    };
};
